import { useState } from 'react'
import { Box, Divider, IconButton, Modal,Paper, Stack, Typography } from '@mui/material'
import CloseIcon from "@mui/icons-material/Close";

import DirectDebitStep1 from './directDebitStep1'
import DirectDebitStep2 from './directDebitStep2'
import DirectDebitStep3 from './directDebitStep3'
import custom from '../../styles/mui/szVariables.json'
import { analyticsPage, analyticsDomain, analyticsCta } from '../../services/constants'
import { sendClickAnalytics, sendViewAnalytics } from '../common/util/util'

export default function DirectDebitPopup({ open, setOpen }: any) {
  const [currentStep, setCurrentStep] = useState(1)

  const handleClose = () => {
    setOpen(false)
    setCurrentStep(1)
  }

  const handleContinue = (toStep: number) => {
    try {
      let name = analyticsCta.directDebitFormEntry
      if(currentStep===1) {
        sendViewAnalytics('/profile', {
              domain: analyticsDomain.profile,
              name: analyticsPage.directDebitFormTandC
            })
      }
      if(currentStep===2) {
        name = analyticsCta.directDebitConsent
      }
      if(currentStep===3) {
        name = analyticsCta.directDebitFormSubmitted
      }
      sendClickAnalytics('/profile', {
          domain: analyticsDomain.profile,
          name,
          metadata: {},
        })
    } catch {
      console.log('click analytics failed')
    }
    if(toStep) {
        setCurrentStep(toStep)
    } else if (currentStep < 3) {
      setCurrentStep(currentStep + 1)
    } else {
      console.log('All steps completed')
      handleClose()
    }
  }

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <DirectDebitStep1 onContinue={handleContinue} />
      case 2:
        return <DirectDebitStep2 onContinue={handleContinue} />
      case 3:
        return <DirectDebitStep3 onContinue={handleContinue} />
      default:
        handleClose()
        return null
    }
  }

  return (
    <Modal
        open={open}
        disableEscapeKeyDown={true}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{ 
          display:'flex', 
          alignItems:'center',
          justifyContent:'center',
          width: "100%"
        }}
      >
      <Paper elevation={0} 
            sx={{ 
              borderRadius: custom.corners5, 
              border: custom.border, 
              width: { 
                  xs:'90vw', 
                  sm:'550px', 
                  md:'550px', 
                  lg:'550px'
                } 
            }}>
        <Box p={custom.spacing.sm} maxWidth="100%">
          <Stack alignItems="center" direction="row" >
              <Typography id="modal-title"  
                variant="szHeading.Bold.Small" >
                  Setup direct debit
              </Typography>
              <IconButton id="closeDirectDebitPopup" 
                    onClick={handleClose} 
                    sx={{ 
                      ml: 'auto',
                      p: custom.spacing.xxxs
                    }}>
                  <CloseIcon sx={{ 
                      border: custom.border, 
                      borderRadius: custom.corners2, 
                      background: '#FFF' 
                    }} />
              </IconButton>
          </Stack>
        </Box>
        <Divider />
        {renderStep()}
      </Paper>
    </Modal>
  )
}

